// extracted by mini-css-extract-plugin
export default {"providerListScrollbar":"ProviderList_providerListScrollbar__MNAHd"};